import { ComputedRef, InjectionKey, Ref } from 'vue';

import { useAIChatState } from '@/composables/mcp/useAIChatState';
import { AI_CHAT_MODES } from '@/constants/mcp';

export const ProvidedExportLimitReached: InjectionKey<ComputedRef<boolean>> =
  Symbol('ProvidedExportLimitReached');

export const ProvidedIsSidebarCollapsed: InjectionKey<Ref<boolean>> = Symbol(
  'ProvidedIsSidebarCollapsed',
);

export const ProvidedOnboardingStepsLeft: InjectionKey<Ref<number>> = Symbol(
  'ProvidedOnboardingStepsLeft',
);

export const ProvidedHasCompletedOnboarding: InjectionKey<Ref<boolean>> =
  Symbol('ProvidedHasCompletedOnboarding');

export const ProvidedAIChatVisible: InjectionKey<Ref<boolean>> =
  Symbol('AIChatVisible');
export const ProvidedAIChatState: InjectionKey<
  ReturnType<typeof useAIChatState>
> = Symbol('AIChatState');
export const ProvidedAIChatMode: InjectionKey<
  Ref<(typeof AI_CHAT_MODES)[keyof typeof AI_CHAT_MODES]>
> = Symbol('AIChatMode');
